import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import AnimatedText from './AnimatedText';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Accueil', path: '/' },
    { name: 'À Propos', path: '/about' },
    { name: 'Formules', path: '/plans' },
    { name: 'Projets', path: '/projects' },
    { name: 'Outils', path: '/tools' },
    { name: 'On Vous Aide', path: '/resources' },
    { name: 'RDV', path: '/rdv' },
    { name: 'Contact', path: '/contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-gray-900/95 backdrop-blur-md border-b border-gray-700/50 sticky top-0 z-50 transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Navigation gauche */}
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item, index) => (
              <AnimatedText key={item.name} delay={100 * index}>
                <Link
                  to={item.path}
                  className={`text-sm font-medium font-inter transition-colors duration-200 hover:text-amber-400 hover-glow ${
                    isActive(item.path) ? 'text-amber-400' : 'text-gray-300'
                  }`}
                >
                  {item.name}
                </Link>
              </AnimatedText>
            ))}
          </div>

          {/* Logo et nom à droite sur desktop */}
          <Link to="/" className="hidden md:flex items-center space-x-3">
            <AnimatedText className="text-xl font-inter font-bold text-white" isTitle={true}>
              Soleil d'Azur
            </AnimatedText>
            <div className="w-10 h-10 flex items-center justify-center">
              <img 
                src="/soleil-azur-logo.png" 
                alt="Logo Soleil d'Azur" 
                className="w-10 h-10 object-contain hover:scale-105 transition-transform duration-200"
              />
            </div>
          </Link>

          {/* Menu mobile */}
          <div className="md:hidden flex items-center justify-between w-full">
            {/* Bouton menu mobile à gauche */}
            <button
              className="p-2 rounded-full hover:bg-gray-800 transition-colors hover-glow text-gray-300"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
            
            {/* Logo mobile à droite */}
            <Link to="/" className="flex items-center space-x-2">
              <span className="text-lg font-inter font-bold text-white">Soleil d'Azur</span>
              <img 
                src="/soleil-azur-logo.png" 
                alt="Logo Soleil d'Azur" 
                className="w-8 h-8 object-contain"
              />
            </Link>
          </div>
        </div>

        {/* Navigation mobile */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-gray-700/50">
            <div className="flex flex-col space-y-2">
              {navItems.map((item, index) => (
                <AnimatedText key={item.name} delay={50 * index}>
                  <Link
                    to={item.path}
                    className={`px-4 py-3 text-base font-medium font-inter transition-colors duration-200 hover:text-amber-400 hover:bg-gray-800 rounded-full hover-glow ${
                      isActive(item.path) ? 'text-amber-400 bg-gray-800' : 'text-gray-300'
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.name}
                  </Link>
                </AnimatedText>
              ))}
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
